__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.6.1-25162f4-10736/_next/";